"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var react_1 = tslib_1.__importStar(require("react"));
var StyledSignaturePad_1 = require("./StyledSignaturePad");
var signature_pad_1 = tslib_1.__importDefault(require("signature_pad"));
var sizeRatio = 1 / 3; // Hight/Width
var SignaturePopup = /** @class */ (function (_super) {
    tslib_1.__extends(SignaturePopup, _super);
    function SignaturePopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.padRef = react_1.createRef();
        _this.state = {
            isEmpty: true
        };
        _this.applyRatio = function () {
            var _a = _this.props.ratio, ratio = _a === void 0 ? sizeRatio : _a;
            var pixelRatio = Math.max(window.devicePixelRatio || 1, 1);
            if (_this.padRef.current) {
                var ctx = _this.padRef.current.getContext('2d');
                _this.padRef.current.width = _this.padRef.current.offsetWidth * pixelRatio;
                _this.padRef.current.height = _this.padRef.current.offsetWidth * pixelRatio * ratio;
                if (ctx) {
                    ctx.scale(pixelRatio, pixelRatio);
                }
            }
        };
        _this.clear = function () {
            if (_this.signatureCanvas) {
                _this.signatureCanvas.clear();
            }
            _this.setState({ isEmpty: true });
        };
        _this.handleSave = function () {
            if (_this.signatureCanvas) {
                _this.props.saveSignature(_this.signatureCanvas.toDataURL());
            }
        };
        return _this;
    }
    SignaturePopup.prototype.componentDidMount = function () {
        var _this = this;
        if (this.padRef.current) {
            this.signatureCanvas = new signature_pad_1.default(this.padRef.current, {
                onEnd: function () {
                    _this.setState({ isEmpty: false });
                }
            });
            this.applyRatio();
            this.signatureCanvas.clear();
        }
        window.addEventListener('resize', debounce_1.default(this.applyRatio, 50));
    };
    SignaturePopup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', debounce_1.default(this.applyRatio, 50));
    };
    SignaturePopup.prototype.render = function () {
        var closeModal = this.props.closeModal;
        var isEmpty = this.state.isEmpty;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledSignaturePad_1.StyledCanvas, { ref: this.padRef, id: "signature-pad" }),
            react_1.default.createElement(StyledSignaturePad_1.StyledLinkBar, null,
                react_1.default.createElement(StyledSignaturePad_1.StyledLinkButton, { disabled: isEmpty, onClick: this.handleSave, "aria-label": "save-signature" }, "Save"),
                react_1.default.createElement(StyledSignaturePad_1.StyledLinkButton, { onClick: this.clear, "aria-label": "clear-signature" }, "Clear"),
                react_1.default.createElement(StyledSignaturePad_1.StyledLinkButton, { onClick: closeModal, "aria-label": "close-signature-popup", "data-testid": "signature-close-button" }, "Close"))));
    };
    return SignaturePopup;
}(react_1.default.PureComponent));
exports.default = SignaturePopup;
//# sourceMappingURL=SignaturePopup.js.map